import React from 'react';
import { HorizontalNav } from './HorizontalNav';

interface LayoutProps {
  children: React.ReactNode;
  activeModule: string;
  setActiveModule: (id: string) => void;
}

export function Layout({ children, activeModule, setActiveModule }: LayoutProps) {
  return (
    <div className="w-full bg-[#f8f9fa] font-sans text-gray-900 pb-16">
      <div className="max-w-7xl mx-auto pt-6 px-4 sm:px-6 lg:px-8">
        <HorizontalNav activeModule={activeModule} setActiveModule={setActiveModule} />
        
        <main className="mt-8 transition-all duration-300">
          <div className="max-w-5xl">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
